import { Tag } from 'antd';
import React from 'react';

type CardStatus = 'pending-registration' | 'pending-activation' | 'activated' | 'dispatched' | 'closed' | 'active' | 'inactive';

export const renderStatus = (status: CardStatus) => {
  const statusConfig = {
    'pending-registration': {
      color: 'warning',
      text: 'PENDING REGISTRATION',
    },
    'pending-activation': { color: 'processing', text: 'PENDING ACTIVATION' },
    activated: { color: 'success', text: 'ACTIVATED' },
    dispatched: { color: 'blue', text: 'DISPATCHED' },
    closed: { color: 'error', text: 'CLOSED' },
    active: { color: 'success', text: 'ACTIVE' },
    inactive: { color: 'warning', text: 'INACTIVE' },
  };

  const config = statusConfig[status] || {
    color: 'default',
    text: status.toUpperCase(),
  };
  return <Tag color={config.color}>{config.text}</Tag>;
}; 